import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../ui/Reveal';
import Icon from '../ui/Icon';
import { COMPANY } from '../../data/site';

export default function CTABanner() {
  return (
    <section className="section--tight">
      <div className="container">
        <Reveal>
          <div className="cta-banner">
            <span className="eyebrow"><span className="dot" />Start a project</span>
            <h2>Tell us what you're building. We'll tell you how we'd ship it.</h2>
            <p className="lede">
              15-minute intro call, no pitch deck, no commitment. By the end you'll have a clearer
              plan — whether you work with us or not.
            </p>
            <div className="cta-banner__row">
              <Link className="btn btn--primary btn--lg" to="/contact">
                Book an intro call <Icon name="arrow" size={14} className="arrow" />
              </Link>
              <a className="btn btn--ghost btn--lg" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
            </div>
            <div className="cta-banner__meta">
              <div>
                <div className="label">Response</div>
                <div className="val">Within one business day</div>
              </div>
              <div>
                <div className="label">Engagements from</div>
                <div className="val">$24k · 4-week sprint</div>
              </div>
              <div>
                <div className="label">Currently booking</div>
                <div className="val">{COMPANY.status.replace('Now booking · ', '')} · 2 slots</div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
